import { Inject, Injectable } from '@rxdi/core';
import { HotKeysService } from '@rxdi/hotkeys';
import { css, html } from '@rxdi/lit-html';
import { GlobalMenuService } from '@rxdi/ui-kit/global-menu';
const style = css`
  .container {
    color: black;
    margin-top: 100px;
  }
  .recent {
    padding: 20px;
  }
`;
const template = html`<style>
    ${style}
  </style>
  <div class="container">
    <div class="recent">Recently used</div>
    <div class="recent">Recently used</div>
  </div> `;
@Injectable({ init: true })
export class HotKeysProvider {
  @Inject(HotKeysService)
  private hotkeys: HotKeysService;

  @Inject(GlobalMenuService)
  private gloablMenuService: GlobalMenuService;

  get rightKey() {
    return this.hotkeys.bind('right');
  }

  get upKey() {
    return this.hotkeys.bind('up');
  }

  get downKey() {
    return this.hotkeys.bind('down');
  }
  get shiftKeyPlusDown() {
    return this.hotkeys.bind('shift+down');
  }

  get shiftKeyPlusUp() {
    return this.hotkeys.bind('shift+up');
  }

  get leftKey() {
    return this.hotkeys.bind('left');
  }
  get enterKey() {
    return this.hotkeys.bind('enter');
  }
  get spaceKey() {
    return this.hotkeys.bind('space');
  }
  get backKey() {
    return this.hotkeys.bind('backspace');
  }

  get ctrlEnter() {
    return this.hotkeys.bind('shift+enter');
  }

  get ctrlMention() {
    return this.hotkeys.bind('shift+2');
  }

  get escapeKey() {
    return this.hotkeys.bind('escape');
  }

  private menuOpened: boolean;

  OnInit() {
    this.gloablMenuService.getOpenSubject().subscribe((menuOpened) => (this.menuOpened = menuOpened));

    this.hotkeys.bind('tab').subscribe((event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.menuOpened) {
        this.gloablMenuService.close();
      } else {
        this.gloablMenuService.open(template);
      }
    });
  }

  bind() {
    return this.hotkeys.bind('space');
  }
}
